import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
import user from './user/reducer';
import upload from './upload/reducer';
import validation_document_review from './validation_document_review/reducer';
import equipment_schedule_maintenance from './equipment_schedule_maintenance/reducer';
import request from './request/reducer';
import request_detail from './request_detail/reducer';
import task from './task/reducer';
import task_equipment from './task_equipment/reducer';
import search from './search/reducer';
import award from './award/reducer';
import award_detail from './award_detail/reducer';
import delivery_plan from './delivery_plan/reducer';
import vehicle from './vehicle/reducer';
import employee from './employee/reducer';
import task_employee from './task_employee/reducer';
import task_vehicle from './task_vehicle/reducer';
import ambulance from './ambulance/reducer';

const reducers = combineReducers({
  user,
  upload,
  menu,
  settings,
  authUser,
  validation_document_review,
  equipment_schedule_maintenance,
  request,
  request_detail,
  task,
  task_equipment,
  search,
  award,
  award_detail,
  delivery_plan,
  vehicle,
  employee,
  task_employee,
  task_vehicle,
  ambulance
});

export default reducers;
